import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-961fa6c6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "container"
};
const _hoisted_2 = {
  key: 0,
  class: "alert-box"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "message"
}, "正在活跃中，该任务未提交审核，任务结果可能产生变更", -1));
const _hoisted_4 = {
  key: 1
};
const _hoisted_5 = {
  class: "top"
};
const _hoisted_6 = {
  class: "head"
};
const _hoisted_7 = {
  class: "store-name"
};
const _hoisted_8 = {
  class: "address"
};
const _hoisted_9 = {
  class: "code"
};
const _hoisted_10 = {
  style: {
    "padding-top": "0.2rem",
    "background": "#ffffff",
    "border-radius": "0.2rem 0.2rem 0.2rem 0.2rem"
  }
};
const _hoisted_11 = {
  style: {
    "height": "0.28rem",
    "margin-right": "0.05rem"
  }
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "上一页", -1));
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "下一页", -1));
const _hoisted_14 = {
  style: {
    "height": "0.28rem",
    "margin-left": "0.05rem"
  }
};
const _hoisted_15 = {
  key: 1,
  class: "content"
};
const _hoisted_16 = {
  class: "contentheader"
};
const _hoisted_17 = {
  key: 0,
  style: {
    "color": "red"
  }
};
const _hoisted_18 = {
  class: "content-box-title"
};
const _hoisted_19 = {
  key: 0,
  class: "content-box-in"
};
const _hoisted_20 = {
  key: 1,
  class: "content-box-anter content-box-in"
};
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "答：", -1));
const _hoisted_22 = {
  key: 2,
  class: "content-box-in"
};
const _hoisted_23 = {
  class: "content-box-in-img"
};
const _hoisted_24 = {
  class: "content-box-img"
};
const _hoisted_25 = ["onClick"];
const _hoisted_26 = {
  key: 3,
  style: {
    "text-align": "right",
    "display": "flex",
    "align-items": "center",
    "justify-content": "right",
    "color": "#5a80b0",
    "margin-top": "0.12rem"
  }
};
const _hoisted_27 = ["onClick"];
const _hoisted_28 = {
  class: "footid"
};
const _hoisted_29 = {
  key: 0
};
const _hoisted_30 = {
  key: 1
};
const _hoisted_31 = {
  class: "bottombtn"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_icon = _resolveComponent("van-icon");
  const _component_van_pagination = _resolveComponent("van-pagination");
  const _component_van_tab = _resolveComponent("van-tab");
  const _component_van_tabs = _resolveComponent("van-tabs");
  const _component_van_empty = _resolveComponent("van-empty");
  const _directive_lazy = _resolveDirective("lazy");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$data.pageData.endTaskFlg ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_van_icon, {
    class: "icon",
    name: "warning"
  }), _hoisted_3])) : _createCommentVNode("", true), $data.pageData.orgTerminalName ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [$data.type1 === 'NEW' ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: _normalizeClass([_ctx.status1 === 'CANCELLED' ? 'over' : 'new', "new"])
  }, "新", 2)) : _createCommentVNode("", true), $data.type1 !== 'NEW' ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: _normalizeClass(_ctx.status1 === 'CANCELLED' ? 'over' : 'notnew')
  }, null, 2)) : _createCommentVNode("", true), _createElementVNode("div", null, _toDisplayString($data.pageData.orgTerminalName), 1)])]), _createElementVNode("div", _hoisted_8, _toDisplayString($data.pageData.province) + _toDisplayString($data.pageData.city) + _toDisplayString($data.pageData.district), 1), _createElementVNode("div", _hoisted_9, "任务：" + _toDisplayString($data.pageData.positionName), 1)]), _createElementVNode("div", _hoisted_10, [_createVNode(_component_van_tabs, {
    active: $data.active,
    "onUpdate:active": _cache[1] || (_cache[1] = $event => $data.active = $event),
    "title-active-color": "#3875C6",
    "title-inactive-color": "#666",
    "line-width": "2rem",
    color: "#3875C6",
    "before-change": $options.changeactive,
    class: "custom-tabs"
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.pageData.data, item => {
      return _openBlock(), _createBlock(_component_van_tab, {
        key: item,
        title: `${item.taskName}（${item.taskCount}）`
      }, {
        default: _withCtx(() => {
          var _item$taskPerformDeta;
          return [item.taskPerformDetails.length !== 1 ? (_openBlock(), _createBlock(_component_van_pagination, {
            key: 0,
            modelValue: $data.currentPage,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.currentPage = $event),
            "page-count": item.taskPerformDetails.length,
            mode: "simple",
            onChange: $options.changepage
          }, {
            "prev-text": _withCtx(() => [_createElementVNode("div", _hoisted_11, [_createVNode(_component_van_icon, {
              name: "arrow-left"
            })]), _hoisted_12]),
            "next-text": _withCtx(() => [_hoisted_13, _createElementVNode("div", _hoisted_14, [_createVNode(_component_van_icon, {
              name: "arrow"
            })])]),
            _: 2
          }, 1032, ["modelValue", "page-count", "onChange"])) : _createCommentVNode("", true), item.taskPerformDetails.length ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_16, [_createTextVNode(_toDisplayString(item.taskPerformDetails[$data.currentPage - 1].subTaskTitle) + " ", 1), item.taskPerformDetails[$data.currentPage - 1].needFaceCompare ? (_openBlock(), _createElementBlock("span", _hoisted_17, "[人像识别]")) : _createCommentVNode("", true)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_item$taskPerformDeta = item.taskPerformDetails[$data.currentPage - 1]) === null || _item$taskPerformDeta === void 0 ? void 0 : _item$taskPerformDeta.data, (item1, index1) => {
            return _openBlock(), _createElementBlock("div", {
              class: "contentbox",
              key: item1
            }, [_createElementVNode("div", _hoisted_18, _toDisplayString(index1 + 1) + "、" + _toDisplayString(item1.question), 1), item1.itemType === 1 || item1.itemType === 0 || item1.itemType === 5 ? (_openBlock(), _createElementBlock("div", _hoisted_19, " 答：" + _toDisplayString(item1.answer && item1.answer.length ? item1.answer[0] : '-'), 1)) : _createCommentVNode("", true), item1.itemType === 2 ? (_openBlock(), _createElementBlock("div", _hoisted_20, [_hoisted_21, _createElementVNode("div", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item1.answer, (item2, index2) => {
              return _openBlock(), _createElementBlock("div", {
                key: item2
              }, [_createElementVNode("div", null, _toDisplayString(index2 + 1) + "、" + _toDisplayString(item2), 1)]);
            }), 128))])])) : _createCommentVNode("", true), item1.itemType === 3 ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item1.answer, img => {
              return _withDirectives((_openBlock(), _createElementBlock("img", {
                key: img,
                alt: "",
                class: "img",
                onClick: $event => $options.preview(img)
              }, null, 8, _hoisted_25)), [[_directive_lazy, img]]);
            }), 128))])])])) : _createCommentVNode("", true), item1.itemType === 3 ? (_openBlock(), _createElementBlock("div", _hoisted_26, [item1.exampleImg ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              onClick: $event => $options.preview(item1.exampleImg)
            }, "查看示例", 8, _hoisted_27)) : _createCommentVNode("", true), item1.exampleImg ? (_openBlock(), _createBlock(_component_van_icon, {
              key: 1,
              name: "arrow"
            })) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]);
          }), 128)), _createElementVNode("div", _hoisted_28, [_createElementVNode("div", null, "触点姓名：" + _toDisplayString(item.taskPerformDetails[$data.currentPage - 1].userName), 1), _createElementVNode("div", null, "提交时间：" + _toDisplayString(item.taskPerformDetails[$data.currentPage - 1].reportTime), 1), item.taskPerformDetails[$data.currentPage - 1].auditorName && !$data.pageData.endTaskFlg ? (_openBlock(), _createElementBlock("div", _hoisted_29, " 审 核 人：" + _toDisplayString(item.taskPerformDetails[$data.currentPage - 1].auditorName), 1)) : _createCommentVNode("", true), item.taskPerformDetails[$data.currentPage - 1].auditTime && !$data.pageData.endTaskFlg ? (_openBlock(), _createElementBlock("div", _hoisted_30, " 审核时间：" + _toDisplayString(item.taskPerformDetails[$data.currentPage - 1].auditTime), 1)) : _createCommentVNode("", true)])])])) : _createCommentVNode("", true)];
        }),
        _: 2
      }, 1032, ["title"]);
    }), 128))]),
    _: 1
  }, 8, ["active", "before-change"])])])) : (_openBlock(), _createBlock(_component_van_empty, {
    key: 2,
    description: $data.success ? '当前暂无可查看的任务执行内容！' : '暂无数据'
  }, null, 8, ["description"])), _createElementVNode("div", _hoisted_31, [$data.activeName ? (_openBlock(), _createElementBlock("button", {
    key: 0,
    class: "btn1",
    onClick: _cache[2] || (_cache[2] = (...args) => $options.goback1 && $options.goback1(...args))
  }, "返回")) : (_openBlock(), _createElementBlock("button", {
    key: 1,
    class: "btn1",
    onClick: _cache[3] || (_cache[3] = (...args) => $options.goback2 && $options.goback2(...args))
  }, "返回"))])]);
}